export const getErrorMessage = (error) => {
    if (error instanceof Error) {
        return error.message;
    }
    return String(error);
};
//# sourceMappingURL=error.utils.js.map